import { Blocks, X } from "lucide-react";
import React, { useState } from "react";

const ImageGrid = ({ images = [], status = "Active" }) => {
  const count = images.length;
  const [open, setOpen] = useState(false);

  if (count === 0) return null;

  const SeeAllButton = () => (
    <div className="absolute bottom-4 right-4 z-10">
      <button onClick={() => setOpen(true)} className="bg-white text-black px-4 py-2 rounded-md border border-slate-300 flex items-center space-x-1 cursor-pointer hover:bg-slate-200 text-sm font-semibold">
        <Blocks size={18} />
        <span>See all {images.length} photos</span>
      </button>
    </div>
  );

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
      case "for sale":
        return "bg-green-600";
      case "pending":
        return "bg-yellow-500";
      case "sold":
      case "not for sale":
      case "off market":
        return "bg-red-600";
      default:
        return "bg-gray-500";
    }
  };

  const Status = () => (
    <div className="absolute top-4 left-4 bg-white text-black px-2 py-1 rounded-md border border-slate-300 flex items-center space-x-2 z-[10] text-xs">
      <span className={`${getStatusColor(status)} rounded-full w-2 h-2`}></span>
      <span>{status}</span>
    </div>
  );

  const Image = ({ src }) => <img alt="" src={src} onClick={() => setOpen(true)} className="w-full h-full object-cover cursor-pointer" />;

  return (
    <>
      {/* ================= GRID ================= */}

      {/* 1 IMAGE */}
      {count === 1 && (
        <div className="w-full h-[400px] max-h-[400px] rounded-xl overflow-hidden relative">
          <Image src={images[0]} />
        </div>
      )}

      {/* 2 IMAGES */}
      {count === 2 && (
        <div className="grid grid-cols-2 gap-2 h-[400px] max-h-[400px] rounded-xl overflow-hidden bg-white">
          {images.slice(0, 2).map((img, i) => (
            <Image key={i} src={img} />
          ))}
        </div>
      )}

      {/* 3–4 IMAGES */}
      {(count === 3 || count === 4) && (
        <div className="grid grid-cols-12 grid-rows-2 gap-2 h-[400px] max-h-[400px] rounded-xl overflow-hidden bg-white relative">
          <div className="col-span-8 row-span-2">
            <Image src={images[0]} />
          </div>

          {images.slice(1, 4).map((img, i) => (
            <div key={i} className="col-span-4">
              <Image src={img} />
            </div>
          ))}

          {count > 3 && <SeeAllButton />}
        </div>
      )}

      {/* 5+ IMAGES */}
      {count >= 5 && (
        <div className="grid grid-cols-12 grid-rows-2 gap-2 h-[400px] max-h-[400px] rounded-xl overflow-hidden bg-white relative">
          <div className="col-span-6 row-span-2">
            <Image src={images[0]} />
          </div>
          {images.slice(1, 5).map((img, i) => (
            <div key={i} className="col-span-3">
              <Image src={img} />
            </div>
          ))}
          <SeeAllButton />
          <Status />
        </div>
      )}

      {/* ================= MODAL ================= */}
      {open && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center" onClick={() => setOpen(false)}>
          {/* CONTENT */}
          <div className="bg-white max-w-3xl w-full max-h-[90vh] overflow-y-auto rounded-lg p-4 relative" onClick={(e) => e.stopPropagation()}>
            {/* CLOSE BUTTON */}
            <button onClick={() => setOpen(false)} className="absolute top-3 right-3 bg-black text-white p-2 rounded-full">
              <X size={18} />
            </button>

            {/* IMAGES LIST */}
            <div className="flex flex-col gap-4 mt-8">
              {images.map((img, i) => (
                <img alt="" key={i} src={img} className="w-full object-cover rounded-md" />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGrid;
